import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { format } from "date-fns";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import DatePicker from "../../../aGlobalDesign/DatePicker/DatePicker";
import Modal from "../../../aGlobalDesign/Modal/Modal";
import IconComponent from "../../../aGlobalDesign/Icons/IconComponent";
import dayjs from "dayjs";
import Tooltips from "../../../aGlobalDesign/Tooltips/Tooltips";
import Drawer from "../../../aGlobalDesign/Modal/Drawer";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Inputs from "../../../aGlobalDesign/Inputs/Inputs";
import DetailCard from "./DetailCard";
import Badge from "../../../aGlobalDesign/Badges/Badge";
import CardCallLog from "../../../aGlobalDesign/Cards/CardCallLog";
import Avatar from "../../../aGlobalDesign/Avatar/Avatar";

class CallLogList extends React.Component {

    constructor() {
        super();
        const end = new Date();
        const start = new Date();
        start.setUTCDate(start.getUTCDate() - 7);
        this.state = {
            searchField: "",
            selectedCallCenter: null,
            temporaryElement: null,
            loadingZones: true,
            forceLoading: true,
            callLogs: null,
            forcePaginationUpdate: 0,
            openDialogDateSelector: false,
            openDialogFilter: false,
            dateSelected: {
                // 7 days before today
                "Start date": start.toISOString().slice(0, 19).replace("T", " "),
                // Today
                "End date": end.toISOString().slice(0, 19).replace("T", " ")
            },
            zoneList: null,
            callCenterList: null,
            filters: null,
            selectedLog: null,
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload")
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle(strings.callLog);
        this.props.ChangeCurrentMenuName("callLog");

        const accessRight = this.props.currentuser.accessrights ? this.props.currentuser.accessrights.hasPermission(15, "consult") : 0;
        this.props.GetRestrictedZones((data) => {

            if (accessRight < 20 || !data.results || data.results.length <= 0) {
                this.setState({ zoneList: [], loadingZones: false });
            }
            else {
                const index = data.results.findIndex(i => i.id === this.props.monitoring.calllogszoneId);
                let zone = null;
                if (index && index >= 0 || index === 0) {zone = data.results[index];}
                if (accessRight <= 20) {
                    this.setState({
                        zoneList: data,
                        loadingZones: false,
                        filters: {
                            zone: zone ? zone : data.results[0],
                            zoneId: zone ? zone.id : data.results[0].id,
                            callCenterList: zone ? zone.secondaryList : data.results[0].secondaryList,
                            callCenter: null,
                            callCenterId: null
                        }
                    },
                    () => this.forcePaginationUpdate());
                }
                else {
                    this.setState({
                        zoneList: data,
                        loadingZones: false,
                        filters: {
                            zone: zone ? zone : null,
                            zoneId: zone ? zone.id : null,
                            callCenterList: zone ? zone.secondaryList : null,
                            callCenter: null,
                            callCenterId: null
                        }
                    },
                    () => this.forcePaginationUpdate());
                }
            }
        }, accessRight
        );
        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedCallCenter: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            const reload = new URLSearchParams(this.props.location.search).get("reload");
            if (reload && this.state.reload !== reload) {
                this.setState({ reload }, () => this.forcePaginationUpdate());
            }
        }
    }

    //#region functions
    ConvertDateForDisplay() {
        const startDate = this.state.dateSelected["Start date"].substring(0, 10);
        const endDate = this.state.dateSelected["End date"].substring(0, 10);

        // extract party of date
        const startDay = startDate.charAt(8) !== "0" ? startDate.slice(8, 10) : startDate.slice(9, 10);
        const endDay = endDate.charAt(8) !== "0" ? endDate.slice(8, 10) : endDate.slice(9, 10);
        const monthstart = startDate.slice(5, 7);
        const monthend = endDate.slice(5, 7);
        const yearstart = startDate.slice(0, 4);
        const yearsend = endDate.slice(0, 4);

        const displayDateSelected = startDay === endDay ?
            startDay + "." + monthstart + "." + yearstart
            :
            startDay + "." + monthstart + "." + yearstart + " ‣ " + endDay + "." + monthend + "." + yearsend;

        return displayDateSelected;
    }

    saveSelectedFilters() {
        this.forcePaginationUpdate();
        this.setState({ openDialogFilter: false });
    }

    exportDatas(datas) {
        const data = datas.results;
        const csvRows = [];
        const headers = ["callId", "dateStart", "callType", "zoneName", "callCenterName", "callCenterFromName"];
        csvRows.push(headers.join(","));

        for (const row of data) {
            const values = headers.map(header => {
                const value = row[header];
                if (Array.isArray(value)) {
                    return `"${value.join("; ")}"`;
                }
                const escaped = ("" + value).replace(/"/g, "\"\"");
                return `"${escaped}"`;
            });
            csvRows.push(values.join(","));
        }

        const csvString = csvRows.join("\n");
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "export_call_log.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    getCallLogStatus(type) {
        switch (type) {
            case "ContinuousCallInterrupted" : return "Erreur réseau";
            case "NominalCallInterrupted" : return "Erreur réseau";
            case "NominalCallCancelledWithPortalInPaused" : return "Intercom en absence";
            case "NominalCallCancelledWithPortalUnavailable" : return "Intercom en absence";
            case "OpenCallOutOfHours" : return "Hors horaires";
            case "NominalCallNotAnswered" : return "Non décroché";
            case "NominalCallCancelledByCaller" : return "Abandonné";
            default :return "Traité";
        }
    }
    //#endregion

    getDurationCall(dateStart, dateEnd) {
        const start = dayjs(dateStart);
        const end = dayjs(dateEnd);

        const durationInSeconds = end.diff(start, "second");
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor(durationInSeconds % 3600 / 60);
        const seconds = durationInSeconds % 60;

        let formattedDuration;

        if (hours > 0) {
            // Display to format "h'min"
            formattedDuration = `${hours}h${minutes}`;
        }
        else {
            // Display to format "minutes'secondes"
            formattedDuration = `${minutes}'${seconds}`;
        }

        return formattedDuration;
    }

    render() {
        const selectedLogData = this.state.selectedLog && this.state.selectedLog.data && this.state.selectedLog.data !== "" ? JSON.parse(this.state.selectedLog.data) : null;
        const isAttachments = selectedLogData && selectedLogData.ClientShareResources && selectedLogData.ClientShareResources !== "" || selectedLogData && selectedLogData.ShareResources && selectedLogData.ShareResources !== "";
        return <>
            <Area
                helmet={strings.helmetCallLog}
                title={strings.callLog}
                information={<Badge text={(this.state.callLogs ? this.state.callLogs.recordCount : 0) + " " + strings.calls} styleColor="grey" />}
                sideButtons={
                    [
                        {
                            type: "secondary-icon",
                            onClick: () => { this.setState({ openDialogDateSelector: true }); },
                            nameIcon: "calendar",
                            text: this.ConvertDateForDisplay()
                        },
                        {
                            type: "secondary-icon",
                            onClick: () => { this.setState({ openDialogFilter: true }); },
                            nameIcon: "filter",
                            disabled: !this.state.zoneList || this.state.zoneList.length <= 0,
                            text: this.state.filters ? this.state.filters.zone && this.state.filters.callCenter ? strings.Filters + "(2)" : this.state.filters.zone || this.state.filters.callCenter ? strings.Filters + "(1)" : strings.Filters + "(0)" : strings.Filters + "(0)"
                        }
                    ]
                }

            >
                <PaginationList
                    key={`calllog-${this.state.reload || "0"}`}
                    forcePaginationUpdate={this.state.forcePaginationUpdate}
                    forceLoading={this.state.forceLoading}
                    onGetElements={
                        (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => {
                            this.setState({ forceLoading: true });

                            if (this.state.loadingZones) {
                                return;
                            }
                            if (!this.state.zoneList || this.state.zoneList.length <= 0) {
                                const emptyList = {
                                    pageNumber: pageNumber,
                                    pageSize: pageSize,
                                    sortExpression: sortExpression,
                                    filterExpression: filterExpression,
                                    tagSearchRequest: tagSearchRequest,
                                    PaginationType: PaginationType,
                                    results: []
                                };
                                this.setState({ callLogs: emptyList, forceLoading: false });
                                onSuccess?.(emptyList);
                            }
                            if (this.state.filters) {
                                const callLogFilters = {
                                    startDate: this.state.dateSelected["Start date"],
                                    endDate: this.state.dateSelected["End date"],
                                    zoneId: this.state.filters.zoneId,
                                    callCenterId: this.state.filters.callCenterId
                                };
                                this.props.GetCallLogsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, callLogFilters, (data) => {
                                    this.setState({ callLogs: data, forceLoading: false });
                                    onSuccess?.(data);
                                });

                                return;
                            }

                            this.setState({ forceLoading: false });
                        }
                    }
                    onSavePagination={(paginationType) => {
                        this.props.EditPaginationListType("calllogs", paginationType);
                        this.setState({ callLogs: { ...this.state.callLogs, PaginationType: paginationType } });
                    }}
                    myElements={{ ...this.state.callLogs,
                        PaginationType: this.props.administration && this.props.administration.paginationtypecalllogs ? this.props.administration.paginationtypecalllogs : this.state.callLogs ? this.state.callLogs.PaginationType : null
                    }}

                    sortOptions={[
                        { sortName: "callId", sortData: "null" },
                        { sortName: "date", sortData: "null" },
                        { sortName: "status", sortData: "null" },
                        { sortName: "zone", sortData: "null" },
                        { sortName: "origin", sortData: "null" },
                        { sortName: "callCenter", sortData: "null" },
                        { sortName: "duration", sortData: "null" },
                        { sortName: "categories", sortData: "null" }
                    ]}

                    tableElement={(element) => {
                        return [
                            {
                                colTitle: strings.ID,
                                fixedWidth: "100px",
                                lockWidth: true,
                                sortIndex: 0,
                                colContent: element ? "#" + element.callId : null
                            },
                            {
                                colTitle: strings.SortStatus,
                                sortIndex: 2,
                                fixedWidth: "150px",
                                colContent: element && element.callType ? this.getCallLogStatus(element.callType) : null
                            },
                            {
                                colTitle: strings.category,
                                fixedWidth: "110px",
                                sortIndex: 7,
                                colContent: element && element.categoryName ? element.categoryName : "—"
                            },
                            {
                                colTitle: strings.Date,
                                fixedWidth: "180px",
                                lockWidth: true,
                                centerHeader: true,
                                sortIndex: 1,
                                colContent: element && element.dateStart ? this.props.parseDate(element.dateStart) : null
                            },
                            {
                                colTitle: strings.Duree,
                                fixedWidth: "100px",
                                lockWidth: true,
                                justify: "center",
                                sortIndex: 6,
                                colContent: element && element.dateStart && element.dateEnd ? this.getDurationCall(element.dateStart, element.dateEnd) : "0'0"
                            },
                            {
                                colTitle: strings.SortOrigin,
                                fixedWidth: "200px",
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    const logdata = value && value.data && value.data !== "" ? JSON.parse(value.data) : null;
                                    const clientName = value && value.clientName && value.clientName !== "anonymous" && value.clientName !== "" ? value.clientName : null;
                                    let inside = null;
                                    if (value && value.callCenterFromName) {
                                        inside = <span style={{ display: "inline-flex", alignItems: "center" }}>
                                            <span style={{ color: "var(--grey-base)", marginRight: 5, display: "inline-flex", alignItems: "center" }}>
                                                <IconComponent nameIcon="arrowRight" color="grey" />
                                                {" TR "}
                                            </span>
                                            {value.callCenterFromName}
                                        </span>
                                        ;

                                    }
                                    else if (logdata && logdata.CallType && logdata.CallType !== "Capsule" && logdata.CallType !== "") {
                                        inside = logdata.CallType + (clientName ? " · " + clientName.replace("Webcall ", "") : "");
                                    }
                                    else if (clientName) { inside = value.clientName.replace("Webcall ", "Webcall · ");}
                                    else { inside = "Webcall";}
                                    return <span style={{ textAlign: "left", padding: "0 10px", width: "calc(100% - 20px)" }}>{inside}</span>;
                                },
                                colContent: element ? {
                                    data: element.data,
                                    callCenterFromName: element.callCenterFromName,
                                    clientName: element.clientName
                                } : null
                            },
                            {
                                colTitle: strings.Zone,
                                fixedWidth: "150px",
                                colContent: element && element.zoneName ? element.zoneName : null
                            },
                            {
                                colTitle: strings.SortCallCenter,
                                sortIndex: 5,
                                fixedWidth: "200px",
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    let inside = null;
                                    if (value && value.callCenterName) {
                                        if (value.idTransferTo) {
                                            inside = <>
                                                <span style={{ display: "inline-flex", alignItems: "center" }}>
                                                    {value.callCenterName}
                                                </span>
                                                <span style={{ color: "var(--grey-base)", display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>
                                                    {" TR "}
                                                    <IconComponent nameIcon={"arrowRight"} color="grey" />
                                                </span>
                                            </>;
                                        }
                                        else {
                                            inside = value.callCenterName;
                                        }
                                    }
                                    else {inside = "";}
                                    return <span style={{ textAlign: "left", padding: "0 10px", width: "calc(100% - 20px)" }}>{inside}</span>;
                                },
                                colContent: element ? {
                                    callCenterName: element.callCenterName,
                                    idTransferTo: element.idTransferTo
                                } : null
                            },
                            {
                                colTitle: strings.agent,
                                fixedWidth: "180px",
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    let inside = null;
                                    if (value) {
                                        inside = <div style={{ display: "flex", flexWrap: "nowrap", gap: "4px", alignItems: "center", minWidth: 0 }}>
                                            {
                                                value.agentThumbnail ? <div style={{ flex: "0 0 auto" }}><Avatar
                                                    href={JSON.parse(value.agentThumbnail).PhotoURL}
                                                /></div> : null
                                            }
                                            {
                                                value.agentName ? <span style={{
                                                    minWidth: 0,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }}>{value.agentName}</span> : null
                                            }
                                        </div>;
                                    }
                                    else {inside = "";}
                                    return <div style={{ textAlign: "left", padding: "0 10px", width: "calc(100% - 20px)" }}>{inside}</div>;
                                },
                                colContent: element ? {
                                    agentName: element.data ? JSON.parse(element.data).AgentName : null,
                                    agentThumbnail: element.data ? JSON.parse(element.data).AgentThumbnail : null
                                } : null
                            },
                            {
                                colTitle: strings.SortRating,
                                fixedWidth: "150px",
                                lockWidth: true,
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (value) {
                                        return <div className="bloc-stars" style={{ display: "flex", flexDirection: "row", gap: "4px", padding: "0 10px",
                                            justifyContent: "flex-end", opacity: value.noteClient ? "1" : "0.25" }}>
                                            {
                                                [1, 2, 3, 4, 5].map((ar) => {
                                                    const note = value.noteClient && Number(value.noteClient) === 0 ? 1 : Number(value.noteClient);
                                                    return (
                                                        <IconComponent
                                                            key={ar}
                                                            nameIcon="star"
                                                            dimensions="20"
                                                            fill={true}
                                                            color={note < ar ? "grey-light" : "carbone"}
                                                        />
                                                    );
                                                })
                                            }
                                        </div>;
                                    }
                                    else {return "";}
                                },
                                colContent: element ? {
                                    noteClient: element.noteClient
                                } : null
                            },
                            {
                                colTitle: "",
                                colType: "actions",
                                actions: [0],
                                colContent: [
                                    <ButtonSkaRound
                                        key={"dots"}
                                        type="primary"
                                        onClick={() => {
                                            this.props.GetSecondaryCategoriesList(
                                                element.zoneId,
                                                (data) => {
                                                    this.setState({ selectedLog: { ...element, categories: data } });
                                                }
                                            );
                                        }}
                                        nameIcon="dots"
                                    />
                                ]
                            }
                        ];
                    }}
                />
            </Area>
            <Drawer open={this.state.selectedLog}
                onClose={() => this.setState({ selectedLog: null })}
                title="Détails de l’appel"
                validationIcon={"save"}
                validationTitle={strings.register}
                onValidate={ () => {
                    if (this.state.selectedLog.data && this.state.selectedLog.data !== "") {
                        const calllogData = JSON.parse(this.state.selectedLog.data);
                        this.props.EditCallLogData(
                            this.state.selectedLog.idSession,
                            calllogData,
                            () => {
                                this.setState({ selectedLog: null });
                                this.forcePaginationUpdate();
                            }
                        );
                    }
                    else {
                        this.setState({ selectedLog: null });
                    }
                } }
            >
                {this.state.selectedLog ? <>
                    <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                        <Inputs
                            field={
                                {
                                    type: "selectElement",
                                    title: strings.category,
                                    preventEmpty: true,
                                    elementsList: this.state.selectedLog.categories,
                                    selectedElementId: this.state.selectedLog.categoryId,
                                    onSelectElement: (element) => {
                                        const sl = { ...this.state.selectedLog };
                                        const dt = sl && sl.data && sl.data !== "" ? JSON.parse(sl.data) : {};
                                        dt.CategoryId = element.id;
                                        sl.data = JSON.stringify(dt);
                                        sl.categoryId = element.id;
                                        sl.categoryName = element.name;
                                        this.setState({ selectedLog: sl });
                                    }
                                }
                            }
                        />
                    </div>
                    <Inputs field={{ type: "divider" }}/>
                    <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "20px" }}>
                        <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "20px" }}>
                            <DetailCard
                                title={strings.ID}
                                info={"#" + this.state.selectedLog.callId}
                            />
                            <DetailCard
                                title={strings.Date}
                                info={this.state.selectedLog.dateStart ? this.props.parseDay(this.state.selectedLog.dateStart) : null}
                            />
                            <DetailCard
                                title={strings.category}
                                info={this.state.selectedLog.categoryName ? this.state.selectedLog.categoryName : "—"}
                            />
                            <DetailCard
                                title={strings.SortStatus}
                                info={
                                    this.state.selectedLog && this.state.selectedLog.callType ? this.getCallLogStatus(this.state.selectedLog.callType) : null
                                }
                            />
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "20px" }}>
                            <DetailCard
                                title={strings.Zone}
                                info={this.state.selectedLog.zoneName}
                            />
                            <DetailCard
                                title={strings.duree}
                                info={this.state.selectedLog.dateStart && this.state.selectedLog.dateEnd ?
                                    <Tooltips
                                        htmlTooltip={`${this.props.parseHour(this.state.selectedLog.dateStart)} ‣ ${this.props.parseHour(this.state.selectedLog.dateEnd)}`}
                                        placement="left"
                                        htmlElementHover={
                                            <span style={{ textDecoration: "underline" }}>
                                                { this.getDurationCall(this.state.selectedLog.dateStart, this.state.selectedLog.dateEnd)}
                                            </span>
                                        }
                                    /> : null}
                            />
                            <DetailCard
                                title={strings.CallCenters}
                                info={this.state.selectedLog.callCenterName ? this.state.selectedLog.callCenterName : "—"}
                            />
                            <DetailCard
                                title={strings.SortRating}
                                info={
                                    <div className="bloc-stars" style={{ display: "flex", flexDirection: "row", gap: "4px",
                                        justifyContent: "flex-end", opacity: this.state.selectedLog.noteClient ? "1" : "0.25" }}>
                                        {
                                            [1, 2, 3, 4, 5].map((ar) => {
                                                const note = this.state.selectedLog.noteClient && Number(this.state.selectedLog.noteClient) === 0 ? 1 : Number(this.state.selectedLog.noteClient);
                                                return (
                                                    <IconComponent
                                                        key={ar}
                                                        nameIcon="star"
                                                        dimensions="20"
                                                        fill={true}
                                                        color={note < ar ? "grey-light" : "carbone"}
                                                    />
                                                );
                                            })
                                        }
                                    </div>
                                }
                            />
                        </div>
                    </div>
                    <Inputs field={{ type: "divider" }}/>
                    <div style={{ fontWeight: "700", fontSize: "22px", color: "var(--primary-base)" }}>{strings.Attachments}</div>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                        paddingBottom: "20px",
                        overflowX: "scroll",
                        overflowY: "hidden",
                        minHeight: isAttachments ? "210px" : null
                    }}>
                        {
                            selectedLogData && selectedLogData.ClientShareResources && selectedLogData.ClientShareResources !== "" ?
                                JSON.parse(selectedLogData.ClientShareResources).map((res) => {
                                    const key = res?.id ?? res?.Id ?? res?.uri ?? res?.Uri ?? res?.name ?? res?.Name ?? index;
                                    return <CardCallLog
                                        key={key}
                                        resource={res}
                                        isClientShare={true}
                                    />;
                                }) : null
                        }
                        {
                            selectedLogData && selectedLogData.ShareResources && selectedLogData.ShareResources !== "" ?
                                JSON.parse(selectedLogData.ShareResources).map((res) => {
                                    const key = res?.id ?? res?.Id ?? res?.uri ?? res?.Uri ?? res?.name ?? res?.Name ?? index;
                                    return <CardCallLog
                                        key={key}
                                        resource={res}
                                        isClientShare={false}
                                    />;
                                }) : null
                        }
                    </div>
                    <Inputs field={{ type: "divider" }}/>
                    <div style={{ fontWeight: "700", fontSize: "22px", color: "var(--primary-base)" }}>{strings.Notes}</div>
                    <div>{
                        (selectedLogData && selectedLogData.AgentName ? "Par " + selectedLogData.AgentName : "")
                    + (this.state.selectedLog.dateStart ? " le " + this.props.parseDate(this.state.selectedLog.dateStart) : null)
                    }</div>
                    <Inputs field={{
                        type: "textarea",
                        onChange: (e) => {
                            const sl = { ...this.state.selectedLog };
                            const dt = sl && sl.data && sl.data !== "" ? JSON.parse(sl.data) : {};
                            dt.Notes = e.target.value;
                            sl.data = JSON.stringify(dt);
                            this.setState({ selectedLog: sl });
                        },
                        value: selectedLogData ? selectedLogData.Notes : ""
                    }}/>
                </> : null}
            </Drawer>
            <DatePicker open={this.state.openDialogDateSelector}
                blockFutureDates={true}
                onClose={ () => this.setState({ openDialogDateSelector: false }) }
                onValidate={(range) => {
                    const start = dayjs(range.startDate);
                    const end = dayjs(range.endDate);

                    const normalizedStart = start.startOf("day").format("YYYY-MM-DD HH:mm:ss");
                    const normalizedEnd = end.endOf("day").format("YYYY-MM-DD HH:mm:ss");

                    this.setState({
                        dateSelected: {
                            "Start date": normalizedStart,
                            "End date": normalizedEnd
                        },
                        openDialogDateSelector: false
                    }, this.forcePaginationUpdate );
                }}
            />
            <Modal open={this.state.openDialogFilter}
                onClose={() => {
                    this.setState({ openDialogFilter: false });
                }}
                onValidate={ () => this.saveSelectedFilters() }
                title={strings.Filters}
                icon={"filter"}
                fields={this.state.filters ?
                    [
                        {
                            type: "selectElement",
                            title: strings.Zones,
                            adjustHeight: true,
                            placeholder: strings.AllZones,
                            preventEmpty: !this.props.currentuser.accessrights || this.props.currentuser.accessrights.hasPermission(15, "consult") === 20,
                            elementsList: this.state.zoneList,
                            selectedElementId: this.state.filters.zoneId,
                            onSelectElement: (element) => {
                                const temp = this.state.filters;
                                temp.zoneId = element ? element.id : null;
                                temp.zone = element;
                                temp.callCenterList = element ? element.secondaryList : null;
                                temp.callCenterId = null;
                                temp.callCenter = null;
                                this.setState({ filters: temp });
                            }
                        },
                        {
                            type: "selectElement",
                            openTop: true,
                            title: strings.CallCenters,
                            adjustHeight: true,
                            placeholder: strings.allCallCenters,
                            elementsList: this.state.filters.callCenterList ? { results: this.state.filters.callCenterList } : this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.filters.callCenterId,
                            onSelectElement: (element) => {
                                const temp = this.state.filters;
                                temp.callCenterId = element ? element.id : null;
                                temp.callCenter = element;
                                this.setState({ filters: temp });
                            }
                        }
                    ] : null
                }
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(CallLogList);
